import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ExpandMore } from '@material-ui/icons';

import { Accordion, AccordionDetails, AccordionSummary } from '../../../material-ui/Accordion';
import { Typography } from '../../../material-ui/Typography';
import { Documents } from './Documents';
import { getCurrentDocuments } from '../../../../selectors/documents';
import { AIRPORT_DOCUMENTS } from '../constants';
import { useStyles } from '../useStyles';

export const AirportDocuments = memo(({ expanded, onChangeExpand }) => {
    const airportDocuments = useSelector(getCurrentDocuments);
    const { t: translate } = useTranslation();
    const classes = useStyles();
    const countDocuments = airportDocuments.count;

    const handleChange = useCallback(() => onChangeExpand(AIRPORT_DOCUMENTS), []);

    if (!airportDocuments || countDocuments === 0) {
        return null;
    }

    return (
        <Accordion expanded={expanded} onChange={handleChange}>
            <AccordionSummary expandIcon={<ExpandMore />} IconButtonProps={{ size: 'small' }}>
                <Typography>{`${translate('labels.documents')} (${countDocuments})`}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.content}>
                {Object.keys(airportDocuments.documents).map((key) => (
                    <div key={key}>
                        <div className={classes.divAirport}>
                            <Typography className={classes.airport}>{key}</Typography>
                        </div>
                        <div className={classes.content}>
                            <Documents documents={airportDocuments.documents[key]} />
                        </div>
                    </div>
                ))}
            </AccordionDetails>
        </Accordion>
    );
});

AirportDocuments.displayName = 'AirportDocuments';
